// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAkdgQXA-9vt12K5WmQn6rl5kqqSgT2PNI",
  authDomain: "echoesoflunaria.firebaseapp.com",
  projectId: "echoesoflunaria",
  storageBucket: "echoesoflunaria.firebasestorage.app",
  messagingSenderId: "701669624342",
  appId: "1:701669624342:web:bfe907a524561c51a10337",
  measurementId: "G-WV6F2DSGJ5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);

export default app;